import { ViewConfig } from "@lib/views";
import { ClassesColumn } from "@common/types/views/classesView";
import { ClassRow } from "./viewUtils";
import { NameCell } from "./Cells/NameCell";
import { PercentageCell } from "./Cells/PercentageCell";
import { TransactionsCell } from "./Cells/TransactionsCell";
import { ActionsCell } from "./Cells/ActionsCell";

export const createClassesViewConfig = (): ViewConfig<
    ClassRow,
    ClassesColumn,
    never
> => ({
    columns: {
        [ClassesColumn.NAME]: {
            accessorKey: "label",
            name: "Name",
            header: "Name",
            immutable: true,
            cell: NameCell,
            minSize: 200,
            maxSize: 1200,
        },
        [ClassesColumn.PERCENTAGE]: {
            accessorKey: "percentage",
            name: "%",
            header: "%",
            cell: PercentageCell,
            minSize: 80,
            maxSize: 100,
        },
        [ClassesColumn.TRANSACTIONS]: {
            accessorKey: "transactionsCount",
            name: "Transactions",
            header: "Transactions",
            cell: TransactionsCell,
            minSize: 100,
            maxSize: 140,
        },
        [ClassesColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            immutable: true,
            hiddenFromSettings: true,
            cell: ActionsCell,
            minSize: 24 + 24 + 12 + 12 + 24 + 24,
            maxSize: 24 + 24 + 12 + 12 + 24 + 24,
        },
    },
    nesting: {
        enabled: true,
        expandColumn: ClassesColumn.NAME,
        childrenKey: "children",
    },
});
